import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Priya Sharma",
      location: "Mumbai, India",
      text: "The abstract painting I bought from Canvaart completely transformed my living room. The colors are even more vibrant in person. Aanishka was so helpful in helping me choose the right size for my wall.",
      painting: "Sunset Dreams",
      rating: 5
    },
    {
      name: "Rahul Verma",
      location: "Bangalore, India",
      text: "I commissioned a custom portrait of my parents for their 25th anniversary. The attention to detail was incredible — they literally teared up when they saw it. Best gift I've ever given.",
      painting: "Custom Family Portrait",
      rating: 5
    },
    {
      name: "Ananya Gupta",
      location: "Delhi, India",
      text: "Won my first auction on Canvaart! The landscape painting arrived perfectly packaged within 5 days. The certificate of authenticity and personal note made it feel so special.",
      painting: "Himalayan Sunrise",
      rating: 5
    },
    {
      name: "Vikram Mehta",
      location: "Pune, India",
      text: "As an interior designer, I've sourced multiple pieces from Canvaart for client projects. The quality is consistently excellent and my clients always love the custom work.",
      painting: "Multiple Commissions",
      rating: 5
    },
    {
      name: "Sneha Patel",
      location: "Ahmedabad, India",
      text: "I was nervous about buying art online, but the video call preview option made me confident. The painting looks exactly as shown and the texture is beautiful.",
      painting: "Ocean Serenity",
      rating: 5
    },
    {
      name: "Arjun Reddy",
      location: "Hyderabad, India",
      text: "Ordered a large 36x48 inch abstract piece for my office. It arrived in a sturdy wooden crate with zero damage. Everyone who visits compliments it. Highly recommend!",
      painting: "Abstract Motion",
      rating: 5
    }
  ];

  const renderStars = (count) => {
    return Array(count).fill(null).map((_, i) => (
      <span key={i} className="star" aria-hidden="true">★</span>
    ));
  };

  return (
    <section className="testimonials-section" aria-label="Customer testimonials">
      <div className="container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">What Our Collectors Say</h2>
          <p className="testimonials-subtitle">
            Join 200+ happy art lovers who found their perfect piece
          </p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((t, index) => (
            <motion.article
              key={index}
              className="testimonial-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              viewport={{ once: true }}
            >
              <div className="testimonial-rating" aria-label={`Rated ${t.rating} out of 5 stars`}>
                {renderStars(t.rating)}
              </div>
              <blockquote className="testimonial-text">
                <span className="quote-mark">&ldquo;</span>
                {t.text}
              </blockquote>
              <footer className="testimonial-footer">
                <div className="testimonial-avatar">
                  <span>{t.name.charAt(0)}</span>
                </div>
                <div className="testimonial-author">
                  <strong>{t.name}</strong>
                  <span>{t.location}</span>
                </div>
              </footer>
              <div className="testimonial-painting">
                <span>Purchased: {t.painting}</span>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          className="testimonials-trust-bar"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <div className="trust-item">
            <span className="trust-number">4.9/5</span>
            <span className="trust-label">Average Rating</span>
          </div>
          <div className="trust-item">
            <span className="trust-number">200+</span>
            <span className="trust-label">Happy Collectors</span>
          </div>
          <div className="trust-item">
            <span className="trust-number">100%</span>
            <span className="trust-label">Original Artwork</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
